interface Props {
  onHelp?: () => void;
}

export default function GettingStarted({ onHelp }: Props) {
  return (
    <div style={{
      marginBottom: "2rem",
      border: "1px solid var(--color-border-header)",
      borderRadius: "8px",
      backgroundColor: "var(--color-surface)",
      padding: "1rem 1.25rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "1rem",
    }}>
      <p style={{ margin: 0, fontSize: "0.9rem", color: "var(--color-description)" }}>
        The CAI marketplace is <strong>already installed</strong> in Claude Desktop. Just open
        <strong> Customize → Organization Plugins</strong> and click the <strong>+</strong> icon to
        find plug-ins — no file downloads in Claude Desktop. Individual skills aren&rsquo;t listed
        in Organization Plugins, so download those from their detail page and add them manually. Claude
        Code installs from the same marketplace via CLI. See the setup guide for details.
      </p>
      {onHelp && (
        <button
          type="button"
          onClick={onHelp}
          style={{
            flexShrink: 0,
            padding: "0.4rem 0.85rem",
            fontSize: "0.85rem",
            backgroundColor: "transparent",
            color: "var(--color-brand)",
            border: "1px solid var(--color-brand)",
            borderRadius: "4px",
            cursor: "pointer",
            fontWeight: 600,
          }}
        >
          Setup guide
        </button>
      )}
    </div>
  );
}
